import React from 'react';
import classnames from 'classnames';
import { Table, TableColumn } from 'tea-component';
import type { IEntity, ITargetTableProps } from '../../types';
const { removeable, scrollable, autotip } = Table.addons;

export default function TargetTable(props: ITargetTableProps) {
  const {
    entityKey,
    title,
    pleaseSelectTips,
    records,
    onRemove,
    entityRenderer,
    showEntity,
    className,
    hasShortCut,
  } = props;

  const addons = [
    scrollable({
      virtualizedOptions: {
        height: 427,
        itemHeight: 58,
      },
    }),
    removeable({ onRemove }),
    autotip({
      className: 'dbi-add-entities-table-autotip',
      emptyText: pleaseSelectTips,
    }),
  ];

  const columns: TableColumn<IEntity>[] = [
    {
      key: 'data',
      header: title,
      render: (cvm) => {
        if (typeof entityRenderer !== 'function') return null;
        return entityRenderer({ cvm }, '', hasShortCut, showEntity);
      },
    },
  ];

  return (
    <Table
      className={classnames('dbi-target-table', className)}
      recordKey={entityKey}
      columns={columns}
      addons={addons}
      records={records}
    />
  );
}
